import { isDev, isPreview, isProduction, isStaging } from "./environment";

function getBaseUrl() {
  // If we are in a preview (and not staging - remember staging is a preview too)
  if (isPreview() && !isStaging()) {
    return `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`;
  }
  // If staging or production, use NEXT_PUBLIC_ZAPIER_ORIGIN
  if (isStaging() || isProduction) {
    return process.env.NEXT_PUBLIC_ZAPIER_ORIGIN;
  }

  if (isDev() && process.env.NEXT_PUBLIC_PORT) {
    return `http://localhost:${process.env.NEXT_PUBLIC_PORT}`;
  }
  // Fall back to local
  return process.env.PORT
    ? `http://localhost:${process.env.PORT}`
    : "http://localhost:3000";
}
export default getBaseUrl;
